[<template>
  <div>
    <el-table
      :data="claims"
      :default-sort="{ prop: order_column, order: order_type }"
      class="w100"
      stripe
    >
      <el-table-column label="Video" prop="videoid" sortable></el-table-column>
      <el-table-column label="Notes" prop="notes" sortable></el-table-column>
      <el-table-column label="Status" prop="status" sortable>
        <template slot-scope="props">
          <el-tag
            v-if="props.row.status == 'Inactive' || props.row.status == '/'"
            type="danger"
          >
            {{ props.row.status }}
          </el-tag>
          <el-tag v-else type="success">
            {{ props.row.status }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right" width="100%">
        <template slot-scope="props">
          <el-tooltip content="Release claim" placement="right">
            <p
              v-if="props.row.status == 'Inactive' || props.row.status == '/'"
            ></p>
            <el-button
              v-else
              type="success"
              circle
              size="small"
              icon="el-icon-check"
              @click="release(props.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('youtubeRemovalClaims', [
      'claims',
      'loading',
      'order_column',
      'order_type'
    ])
  },

  methods: {
    ...mapActions('youtubeRemovalClaims', ['readClaims', 'releaseClaim']),
    release(row) {
      this.$confirm('You will release this claim. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          row.other.forEach(e => {
            this.releaseClaim({ claimId: e.claimId, row: row.row })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Release cancelled'
          })
        })
    }
  },

  created() {
    this.readClaims()
  }
}
</script>
]
